import {
  cloneStockTableViewState,
  createEmptyStockFilters,
  type StockTableView,
} from '../types/stockTableView.types';

export const SYSTEM_STOCK_TABLE_VIEWS: StockTableView[] = [
  {
    id: 'system-all',
    label: 'Toutes les pièces',
    isSystem: true,
    state: {
      searchQuery: '',
      selectedFilters: createEmptyStockFilters(),
    },
  },
  {
    id: 'system-disponible',
    label: 'Pièces disponibles',
    isSystem: true,
    state: {
      searchQuery: '',
      selectedFilters: {
        ...createEmptyStockFilters(),
        statutElementStock: ['Disponible'],
      },
    },
  },
  {
    id: 'system-reserve',
    label: 'Pièces réservées',
    isSystem: true,
    state: {
      searchQuery: '',
      selectedFilters: {
        ...createEmptyStockFilters(),
        statutElementStock: ['Réservé'],
      },
    },
  },
  {
    id: 'system-neuf',
    label: 'Pièces neuves',
    isSystem: true,
    state: {
      searchQuery: '',
      selectedFilters: {
        ...createEmptyStockFilters(),
        etatPiece: ['Neuf'],
      },
    },
  },
];

export const DEFAULT_STOCK_TABLE_VIEW_ID = SYSTEM_STOCK_TABLE_VIEWS[0].id;

export const getSystemStockTableViewById = (viewId: string): StockTableView | undefined => {
  const view = SYSTEM_STOCK_TABLE_VIEWS.find((item) => item.id === viewId);

  return view ? { ...view, state: cloneStockTableViewState(view.state) } : undefined;
};
